import React, { useEffect, useState, useRef } from 'react'
import avator from '../assets/images/img_avatar3.png'
import pddlogo from '../assets/images/pddlogo.png'
import HashLoader from "react-spinners/HashLoader";
import { css } from "@emotion/core";
import { BrowserRouter as Router, Switch, Route, Link, NavLink } from "react-router-dom";
import { Helmet } from 'react-helmet';
import Swal from 'sweetalert2'
import { GetCustomerName, TryPath } from './ReservationWebApi';



export const ReservationDoctors = () => {

  const [data, setData] = useState([]);
  const [orginalData, setorginalData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [customerName, setCustomerName] = useState('');
  const SearchText = useRef('');

  useEffect(async () => {

    console.log(process.env.REACT_APP_PDD_URL);
    /*     const path ='../assets/images/doctors/00722.png';
    
        console.log(loadImage(path));
        
     */

    console.log('File Exists');
    console.log(TryPath('../assets/images/doctors/00720.jpg'));

    const result = await GetCustomerName()

    if (result.length = 1) {
      setCustomerName(result[0].ConfigValue);
    }


    getbeneficiary();

  }, [])



  const getbeneficiary = async () => {
    setLoading(true);
    const apiUrl = window.BASE_URL + "/api/pdd/ReservationListBeneficiary";
    fetch(apiUrl)
      .then(response => response.json())
      .then((data) => {
        setData(data);
        setorginalData(data);
        setLoading(false);

      },
        (error) => {
          setLoading(false);
          Swal.fire(
            'خطا',
            'خطا سرور ' + error,
            'error'
          );
        })

  }
  const searchTextChange = () => {
    console.log(SearchText.current.value);
    const tmp = orginalData.filter(itm => itm.FirstName.includes(SearchText.current.value) || itm.LastName.includes(SearchText.current.value) || itm.BeneficiaryGroupsName.includes(SearchText.current.value));
    console.log(tmp);
    setData(tmp);
  }

  return (
    <>
      <Helmet>
        <title>نوبت دهي طب پرداز</title>
      </Helmet>
      <link rel="stylesheet" href="../assets/css/bootstrap.min.css"></link>
      <div>
        <div className="nav bg-primary fixed-top pt-2 pb-2">
          <div className="container">
            <div className="row">
              <div className="col-1 pl-0 pr-0" >
                <img src="../Assets/Images/pddlogo.png" alt="" ></img>
              </div>
              <div className="col-6 pl-0 pr-0 pt-2">
                <NavLink to="/" className="header-font mt-0 mb-0 ml-0 mr-1 pl-0 pr-0 text-white d-flex justify-content-start" >نوبت دهي طب پرداز ({process.env.REACT_APP_VERSION})</NavLink>
              </div>
              <div className="col-5 pl-0 pr-0 pt-2">
                <NavLink to="/" className="header-font mt-0 mb-0 ml-4 mr-3 pl-0 pr-0 text-white  d-flex justify-content-end" >{customerName}</NavLink>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <header className="bg-info my-4 pt-5 pb-1 align-items-center">
            <h3 className="display-5">خوش آمديد</h3>
            <p className="lead">جهت نوبت دهي مي توانيد هر يك از پزشكان مورد نظر خود را انتخاب و به صفحه بعدي راهنمائي مي شويد.</p>
          </header>

          {
            loading ?
              <button className="btn btn-primary" type="button" disabled>
                <span className="spinner-border spinner-border-m" role="status" aria-hidden="true" />در حال بارگذاري ....
              </button>
              :
              <div></div>
          }

          <div className="container bg-info">
            <div>

              <div className="form-group pb-3 pt-3 align-items-start">
                <table>
                  <tr>
                    <td pr-2 pl-2>
                      <label>جستجو</label>
                    </td>
                    <td>
                      <input type="text" className="form-control ml-2 mr-2" id="TBSearch" ref={SearchText} onChange={() => searchTextChange()} placeholder="جستجوي پزشك تخصص" />
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>






          <div className="row text-center">
            {
              data.map((itm, index) =>
                (
                  <div className="col-lg-3 col-md-6 mb-4" id={itm.BeneficiaryCode}>
                    <div className="card h-100">
                      <div className="card-body">
                        <img className="doctor-img-size card-img-top w-100 p-3 img-rounded" alt={itm.BeneficiaryPicture} src={TryPath(itm.BeneficiaryPicture) ? itm.BeneficiaryPicture : avator} />
                        <h6>دكتر </h6>
                        <h6 className="text-primary">{itm.FirstName + ' ' + itm.LastName}</h6>
                        <p className="card-text">{'متخصص ' + itm.BeneficiaryGroupsName}</p>
                      </div>
                      <div className="card-footer bg-doctor-footer">
                        <NavLink to={`/Reservationdayselect/${itm.BeneficiaryCode}/${itm.FirstName + ' ' + itm.LastName}`} className="btn btn-bg-color text-white" >انتخاب روز</NavLink>
                      </div>
                    </div>
                  </div>
                ))
            }
          </div>
        </div>
        {/* /.container */}
        {/* Footer */}
      </div>

      <nav className="navbar2 fixed-bottom navbar-light footer-font align-items-center align-self-center">
        <a className="mt-3 footer-font" href="http://www.pdd.ir">كليه حقوق متعلق به شركت طراح داده پيشرو مي باشد - www.pdd.ir</a>
      </nav>

    </>
  )
}
